<template>
  <div class="camp-contents">
    <div class="content-head">
      <p class="menu">
        <span @click="$router.push({ name: 'combat_camp' })">实战营</span><span class="line">/</span
        ><span @click="$router.push({ name: 'combat_camp' })">我的项目</span>
      </p>
      <div class="name flex flex-between">
        <p>{{ detail.name }}</p>
        <div class="group-btn flex" v-if="current_uid === detail.uid">
          <Button
            type="primary"
            class="mr-10"
            @click="
              tplType = 0
              tplVisible = true
            "
            >设为个人项目模板</Button
          >
          <Button
            type="primary"
            @click="
              tplType = 1
              tplVisible = true
            "
            >设为公共项目模板</Button
          >
        </div>
      </div>
    </div>
    <div class="content-bottom">
      <div class="content-bottom-left">
        <p class="title">
          <Img src="/icon-camp-xm.png" />
          <span>项目信息</span>
        </p>
        <div class="info">
          <p class="name">{{ detail.name }}</p>
          <p class="username">
            <span>作者</span>
            <span class="names">{{ detail.username }}</span>
          </p>
          <p class="member">
            <span>创建于</span>
            <span class="date">{{ detail.CreatedAt ? parseTime(detail.CreatedAt) : '' }}</span>
            <Img src="/icon-camp-member.png" />
            <span>成员</span>
            <span>{{ detail.member || 0 }}</span>
          </p>
          <p class="title-line">介绍</p>
          <p class="des">{{ detail.introduce }}</p>
          <p class="title-line">进度</p>
          <p class="progress mt-20px">
            <span>项目进度</span>
            <Progress :percent="detail.progress" strokeColor="#39DA8A" />
          </p>
        </div>
        <div class="btn">
          <p>
            <span @click="editInfo()">
              <Img src="/icon-camp-edit.png" />
            </span>
            <span>修改信息</span>
          </p>
        </div>
      </div>
      <div class="content-bottom-middle">
        <!-- <div class="title head">
          <Img src="/icon-camp-gy.png" />
          <span>概要</span>
        </div> -->
        <div class="content-bottom-middle-bottom">
          <div class="member">
            <p class="title-operate">
              <span class="name"> <Img src="/icon-cy.png" />成员</span>
              <span>
                <span v-if="current_uid === detail.uid" class="mr-20 pointer" @click="addMemberVisible = true"
                  ><Icon type="ios-add-circle-outline" style="margin-right: 5px" /><span>添加成员</span></span
                >
                <span v-if="current_uid === detail.uid" class="pointer"
                  ><Img src="/icon-camp-member.png" /><span @click="inviteVisible = true">邀请成员</span></span
                >
              </span>
            </p>
            <Table :columns="columns" :data="member_list" :height="tableHeight" :lineHeight="45">
              <template slot="job" slot-scope="{ row }">
                <div class="position">
                  <Input v-if="current_uid === row.uid || current_uid === detail.uid" v-model="row.job" :disabled="!row.edit" @on-blur="editMemberJob(row)" />
                  <span v-else>{{ row.job }}</span>
                  <span @click="row.edit = true" class="pointer" v-if="(!row.edit && current_uid === row.uid) || current_uid === detail.uid">
                    <Icon type="md-create" class="pointer" />
                  </span>
                </div>
              </template>
            </Table>
          </div>
          <div class="title head flex">
            <div><Img src="/icon-lcb.png" /> <span>里程碑</span></div>
            <span v-if="current_uid === detail.uid"> <Icon type="ios-add-circle-outline" @click="addMilestone()" /><span>添加里程碑</span> </span>
          </div>

          <div class="milestone-item" v-for="(item, index) in milestone" :key="index">
            <p class="line-m" :style="`height: ${item.taskList.length > 0 ? 66 + 60 * (item.taskList.length - 1) : 0}px`"></p>
            <div class="milestone-item-title">
              <p class="expand cursor-pointer" @click="searchTask(item.id, $event)">
                <Img src="/icon-right.png" />
              </p>
              <p class="status" :class="{ done: item.state }">{{ item.state ? '已完成' : '进行中' }}</p>
              <p>{{ item.event }}</p>
            </div>
            <div class="milestone-item-time">
              <p>
                <Img src="/icon-time.png" />
                周期：{{ item.cycle }}{{ cycleType.get(item.unit) }}
              </p>
              <div class="action flex">
                <p class="cursor-pointer" @click="selectTask(item.id)">
                  <Img src="/icon-list.png" />
                  任务
                </p>
                <p v-if="current_uid === detail.uid" class="cursor-pointer" @click="editPro(item)">
                  <Img src="/icon-camp-edit-h.png" />
                  编辑
                </p>
                <span v-if="current_uid === detail.uid" class="state-btn">
                  <Checkbox v-model="item.state" @on-change="editProState(item)" :disabled="changeLoading">完成 </Checkbox>
                </span>
              </div>
            </div>
            <ul class="task-list-m">
              <li v-for="task in item.taskList" :key="task.id">
                <p class="line"></p>
                <p>{{ task.name }}</p>
                <div class="star">
                  <span>难度：</span>
                  <Img src="/star-m.png" v-for="star in task.difficulty" :key="`${star}-1`" />
                  <Img src="/star.png" v-for="star in 5 - task.difficulty" :key="`${star}-2`" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content-bottom-right">
        <div class="item mb-10 pb-20">
          <p class="title">
            <Img src="/icon-xmck.png" />
            <span>项目仓库</span>
          </p>
          <div class="share">
            <ul>
              <li class="key">代码状态</li>
              <li class="code-state">
                <Button v-if="detail.code_link" class="w500" @click="getCodeAddress()">进入代码仓库(需要登录才可访问)</Button>
                <Poptip v-if="detail.code_link" trigger="hover" title="仓库账号">
                  <span class="look">查看仓库账号</span>
                  <template #content>
                    账号为当前登录账号， 默认密码为账号后8位
                  </template>
                </Poptip>
                <Button v-if="!detail.code_link" :disabled="current_uid !== detail.uid" class="w500" @click="codeVisible = true">初始化代码仓库</Button>
              </li>
            </ul>
            <ul>
              <li class="key">演示地址</li>
              <li>
                <Input placeholder="请输入" v-model.trim="detail.show_link" />
              </li>
              <li class="save-btn">
                <Button type="primary" @click="saveShowLink()" :loading="saveLoading">保存地址</Button>
              </li>
            </ul>
          </div>
        </div>
        <div class="item">
          <p class="title">
            <Img src="/icon-camp-rz.png" />
            <span>项目日志</span>
          </p>
          <div class="log-list">
            <div v-if="log_list.length === 0" class="noData">暂无数据</div>
            <div class="log-list-top" v-else>
              <ul v-for="(item, index) in log_list" :key="index" @mouseover="activeLogTab = index" @mouseout="activeLogTab = -1">
                <p class="date">{{ parseTime(item.date) }}</p>
                <p class="des">{{ item.event }}</p>
                <span class="edit-btn" @click="editLogs(item)" :class="activeLogTab === index && item.creator === current_uid ? 'active' : ''">
                  <Icon type="md-create" class="pointer" />
                </span>
              </ul>
            </div>
            <Page v-if="total > 0" :total="total" @on-change="pageChange" show-total />
          </div>
          <div class="btn">
            <p>
              <span @click="addLogs()">
                <Img src="/icon-camp-edit.png" />
              </span>
              <span>写日志</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <LogForm :logVisible.sync="logVisible" :project_id="detail.id" :logsAdd="logsAdd" :logData="logData" @ok="getLogs" />
    <InfoForm :visible.sync="visible" :project_id="detail.id" :detail="detail" @ok="getDetail" />
    <InviteForm :inviteVisible.sync="inviteVisible" :detail="detail" :project_id="detail.id" @ok="getDetail" />
    <ProForm :proVisible.sync="proVisible" :project_id="detail.id" :rows="rows" :isAdd="isAdd" @ok="getMilestone" />
    <CodeForm :codeVisible.sync="codeVisible" :project_id="detail.id" @ok="getDetail" />
    <Modal v-model="tplVisible" title="提示">
      <p v-if="tplType === 0">确定将此项目设为个人项目模板吗？</p>
      <p v-else-if="privateTaskList.length > 0">
        此项目包含私有任务，为保护内容不可直接设为公共项目模板！<br />
        需先将私有任务推至公共任务库，方可设为公共项目模板！<br />
        私有任务：<span style="color: #468fef;">{{ privateTaskNameList.join('、') }}</span>
        <br />
      </p>
      <p v-else>确定将此项目设为公共项目模板吗？</p>
      <template #footer>
        <Button type="default" @click="tplVisible = false">取消</Button>
        <Button v-if="privateTaskList.length > 0 && tplType === 1" type="primary" @click="$router.push({ name: 'task' })">公开任务</Button>
        <Button v-else type="primary" @click="setTemplate" :loading="setTemplateLoading">确定</Button>
      </template>
    </Modal>
    <TaskModal
      :visible.sync="taskVisible"
      :progress_id="progress_id"
      @ok="
        getMilestone()
        hasPrivateTask()
      "
      :selectTaskArr="selectTaskArr"
      :isAuthor="current_uid === detail.uid"
    />
    <AddMember :visible.sync="addMemberVisible" :project_id="+$route.query.id" @ok="getMember" />
  </div>
</template>
<script>
import { Button, Progress, Table, Icon, Input, Checkbox, Message, Page, Poptip, Modal } from 'view-design'
import Img from '../../components/Img.vue'
import LogForm from './LogForm.vue'
import InfoForm from './InfoForm.vue'
import InviteForm from './InviteForm.vue'
import ProForm from './ProForm.vue'
import CodeForm from './CodeForm.vue'
import TaskModal from './TaskModal.vue'
import AddMember from './AddMember.vue'
import { cycleType } from '../../config/dict'
export default {
  components: {
    Img,
    Button,
    Progress,
    Table,
    Icon,
    Input,
    Page,
    Checkbox,
    Poptip,
    LogForm,
    InfoForm,
    InviteForm,
    ProForm,
    CodeForm,
    Modal,
    TaskModal,
    AddMember
  },
  data() {
    return {
      queryParams: {
        id: undefined
      },
      logQueryParams: {
        page: 1,
        size: 10
      },
      activeLogTab: -1,
      activeProTab: -1,
      visible: false,
      inviteVisible: false,
      proVisible: false,
      logVisible: false,
      changeLoading: false,
      saveLoading: false,
      codeVisible: false,
      current_uid: 0,
      logData: {},
      total: 0,
      isAdd: true,
      logsAdd: true,
      rows: {},
      member_list: [],
      milestone: [],
      log_list: [],
      detail: {},
      tableHeight: 344,
      current_userinfo: {},
      columns: [
        {
          key: 'id',
          title: 'ID'
        },
        {
          key: 'username',
          title: '姓名'
        },
        {
          slot: 'job',
          title: '职位'
        }
      ],
      cycleType: cycleType,
      tplVisible: false,
      tplType: 0,
      taskVisible: false,
      addMemberVisible: false,
      progress_id: 0, // 关联人物里程碑的id
      selectTaskArr: [],
      privateTaskList: [], // 私有任务
      setTemplateLoading: false
    }
  },
  created() {
    this.queryParams.id = +this.$route.query.id
    this.getDetail()
    this.hasPrivateTask()
    this.current_uid = JSON.parse(localStorage.getItem('userinfo')).id
    this.current_userinfo = JSON.parse(localStorage.getItem('userinfo'))
  },
  computed: {
    // 私有任务的名称
    privateTaskNameList() {
      return this.privateTaskList.map(item => item.name)
    }
  },
  methods: {
    // 获取详情
    async getDetail() {
      const params = {
        uriCode: 'API022',
        ...this.queryParams
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)
        this.detail = res
        if (this.detail.id) {
          this.getMember()
          this.getMilestone()
          this.getLogs()
        }
      } finally {
        this.loading = false
      }
    },
    // 修改基本项目信息
    editInfo() {
      if (this.current_uid !== this.detail.uid) {
        Message.warning('只有创建者才可修改！')
        return
      }
      this.visible = true
    },
    pageChange(page) {
      this.logQueryParams.page = page
      this.getLogs()
    },
    // 保存演示地址
    async saveShowLink() {
      if (!this.isMember()) {
        Message.warning('您不是该项目成员！')
        return
      }
      const params = {
        uriCode: 'API023',
        id: this.detail.id,
        life: +this.detail.life,
        introduce: this.detail.introduce,
        progress: +this.detail.progress,
        name: this.detail.name,
        show_link: this.detail.show_link,
        code_link: this.detail.code_link
      }
      try {
        this.saveLoading = true
        await this.$fetch(params)
        Message.success('保存成功')
      } finally {
        this.saveLoading = false
        this.getDetail()
      }
    },
    // 获取成员信息
    async getMember() {
      const params = {
        uriCode: 'API029',
        project_id: this.detail.id,
        page: 1,
        size: 100
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)
        this.member_list = res.list || []
        this.member_list?.forEach(item => {
          item['edit'] = false
        })
      } finally {
        this.loading = false
      }
    },
    // 获取获取里程碑
    async getMilestone() {
      const params = {
        uriCode: 'API032',
        project_id: this.detail.id,
        page: 1,
        size: 100
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)
        const list = res.list || []
        this.milestone = list?.map(item => {
          item.state = item.state === '0' ? false : true
          item.taskList = []
          return item
        })
        // 刷新里程碑都重新收起
        const domArr = document.querySelectorAll('.milestone-item')
        domArr.forEach(item => {
          item.classList.remove('expand')
        })
      } finally {
        this.loading = false
      }
    },
    // 获取日志
    async getLogs() {
      const params = {
        uriCode: 'API036',
        project_id: this.detail.id,
        ...this.logQueryParams
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)
        this.log_list = res.list || []
        this.total = res.total_record
      } finally {
        this.loading = false
      }
    },
    // 获取代码库地址
    async getCodeAddress() {
      if (!this.isMember()) {
        Message.warning('您不是该项目成员！')
        return
      }
      const params = {
        uriCode: 'API041',
        id: this.detail.id
      }
      const res = await this.$fetch(params)
      window.open(res, 'code_link')
    },
    // 添加日志
    addLogs() {
      if (!this.isMember()) {
        Message.warning('您不是该项目成员！')
        return
      }
      this.logVisible = true
      this.logsAdd = true
      this.logData = {}
    },
    // 修改日志
    editLogs(item) {
      if (!this.isMember()) {
        Message.warning('您不是该项目成员！')
        return
      }
      this.logVisible = true
      this.logsAdd = false
      this.logData = { ...item }
    },
    addMilestone() {
      if (!this.isMember()) {
        Message.warning('您不是该项目成员！')
        return
      }
      this.proVisible = true
      this.isAdd = true
    },
    // 是否为项目成员
    isMember() {
      const flag =
        this.member_list?.filter(item => {
          return this.current_uid === item.uid
        }) || []
      return flag.length > 0
    },
    // 修改职位
    async editMemberJob(row) {
      const reg = /^[\u4e00-\u9fa50-9A-Za-z]*$/
      if (!reg.test(row.job)) {
        Message.error('请输入正确的职位名称!')
        return
      }
      const params = {
        uriCode: 'API030',
        id: row.id,
        job: row.job
      }
      try {
        await this.$fetch(params)
        Message.success('修改成功!')
      } finally {
        this.getMember()
      }
    },
    // 修改里程碑
    editPro(item) {
      if (!this.isMember()) {
        Message.warning('您不是该项目成员！')
        return
      }
      this.isAdd = false
      this.rows = { ...item }
      this.proVisible = true
    },
    // 修改里程碑状态
    async editProState(item) {
      if (!this.isMember()) {
        Message.warning('您不是该项目成员！')
        return
      }
      const params = {
        uriCode: 'API034',
        id: item.id,
        project_id: this.detail.id,
        cycle: item.cycle,
        event: item.event,
        unit: item.unit,
        state: item.state === true ? '1' : '0' //0 未完成 1完成
      }

      try {
        this.changeLoading = true
        await this.$fetch(params)
      } finally {
        this.changeLoading = false
        this.getMilestone()
      }
    },
    // 将项目设置为模版库
    async setTemplate() {
      const params = {
        uriCode: 'ZP_API002',
        project_id: this.detail.id,
        type: this.tplType
      }
      try {
        this.setTemplateLoading = true
        await this.$fetch(params)
        Message.success('设置成功！')
        this.tplVisible = false
      } finally {
        this.setTemplateLoading = false
      }
    },
    // 获取里程碑下的任务列表
    async searchTask(progress_id, _event) {
      // 获取祖先元素
      const parentDom = _event.target.closest('.milestone-item')
      // 判断当前是否展开
      if (parentDom.classList.contains('expand')) {
        // 当前展开就收起
        parentDom.classList.remove('expand')
      } else {
        const params = {
          uriCode: 'ZP_API008',
          progress_id
        }
        const res = await this.$fetch(params)
        const index = this.milestone.findIndex(item => item.id === progress_id)
        this.$set(this.milestone, index, { ...this.milestone[index], taskList: res.list })
        // 添加类名，展开
        parentDom.classList.add('expand')
      }
    },
    // 关联任务弹窗
    async selectTask(id) {
      this.selectTaskArr = []
      this.progress_id = id
      const params = {
        uriCode: 'ZP_API008',
        progress_id: id
      }
      const res = await this.$fetch(params)
      this.selectTaskArr = res.list
      this.taskVisible = true
    },
    // 获取项目是否有私有任务
    async hasPrivateTask() {
      const params = {
        uriCode: 'ZP_API0010',
        project_id: +this.$route.query.id
      }
      const res = await this.$fetch(params)
      this.privateTaskList = res.list || []
    }
  }
}
</script>
<style lang="scss">
.camp-contents {
  max-width: 1440px;
  margin: auto;

  .content {
    &-head {
      border-radius: 8px;
      background-color: #fff;
      padding: 16px 24px;
      margin-top: 10px;

      .menu {
        span {
          cursor: pointer;
          line-height: 22px;
        }

        .line {
          margin: 0 8px;
          cursor: default;
        }
      }

      .name {
        line-height: 28px;
        font-size: 20px;
        font-weight: 500;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.85);
        display: flex;
        .ivu-btn {
          width: auto !important;
        }
      }
    }

    &-bottom {
      margin-top: 10px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;

      .title {
        line-height: 22px;
        font-weight: 600;
        color: #1c2a34;
        font-size: 16px;
        padding: 20px 20px 0 20px;

        img {
          height: 20px;
          margin-right: 10px;
          margin-top: -4px;
        }
      }

      .title-line {
        font-size: 16px;
        font-weight: 400;
        color: rgba(28, 42, 52, 0.65);
        line-height: 22px;
      }

      &-left {
        width: 350px;
        margin-right: 10px;
        background-color: #fff;
        border-radius: 8px;

        .info {
          height: calc(100vh - 280px);
          overflow-y: auto;
          padding: 0 20px;
          padding-top: 40px;

          .name {
            font-size: 18px;
            font-weight: 400;
            color: #1c2a34;
            line-height: 25px;
          }

          .username {
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;
            font-weight: 400;
            color: rgba(28, 42, 52, 0.45);
            line-height: 22px;
            margin-top: 12px;

            .names {
              color: #1c2a34;
              margin: 0 10px 0 5px;
            }

            .date {
              margin-left: 5px;
            }
          }

          .member {
            margin-top: 12px;
            margin-bottom: 46px;
            font-weight: 400;
            color: rgba(28, 42, 52, 0.45);

            img {
              height: 18px;
              width: 18px;
              margin: -2px 6px 0 0;
            }

            span {
              margin-right: 6px;
            }
          }

          .des {
            margin-top: 20px;
            font-weight: 400;
            color: rgba(28, 42, 52, 0.65);
            line-height: 22px;
            margin-bottom: 40px;
            word-break: break-all;
          }
        }
      }

      &-middle {
        flex: 1;

        &-bottom {
          height: calc(100vh - 188px);
          overflow-y: auto;
        }

        .head {
          background-color: #fff;
          padding: 20px;
          border-radius: 8px;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          & > span {
            font-size: 14px;
            color: rgba(28, 42, 52, 0.65);
            font-weight: 400;
            i {
              font-size: 16px;
              margin-right: 6px;
              cursor: pointer;
              color: rgba(28, 42, 52, 0.45);
              font-weight: 600;
            }
          }
        }

        .member {
          background-color: #fff;
          padding: 20px;
          border-radius: 8px;

          .title-operate {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            font-weight: 400;
            color: rgba(28, 42, 52, 0.65);
            margin-bottom: 20px;
            .name {
              font-size: 16px;
              color: #1c2a34;
              img {
                width: 20px;
                height: 20px;
              }
            }
            img {
              height: 18px;
              width: 18px;
              margin: -2px 7px 0 0;
            }

            .name {
              font-size: 16px;
              color: #1c2a34;
            }
          }
        }

        .milestone {
          background-color: #fff;
          margin-top: 10px;
          padding: 20px;
          border-radius: 8px;

          .title-operate {
            font-weight: 400;
            color: rgba(28, 42, 52, 0.65);
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            flex-wrap: nowrap;
            margin-bottom: 30px;

            .ivu-icon {
              font-size: 16px;
              font-weight: 600;
              margin: 4px 5px 0 0;
              cursor: pointer;
            }

            .name {
              color: #1c2a34;
              font-size: 16px;
            }
          }

          &-list {
            height: calc(100vh - 1003px);
            overflow-y: auto;
            min-height: 160px;
          }

          &-list ul.active {
            .milestone-section {
              &-middle {
                background: rgba(28, 42, 52, 0.03);
              }

              &-right {
                background: rgba(28, 42, 52, 0.03);
                display: block;
                display: flex;
                width: 145px;
                text-align: center;
                align-items: center;
                justify-items: center;
              }
            }
          }

          &-list ul {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;

            .milestone-section ul:hover {
              &-middle {
                background-color: rgba(28, 42, 52, 0.03) !important;
              }

              &-right {
                background-color: rgba(28, 42, 52, 0.03) !important;
              }
            }

            .milestone-section {
              &-left {
                height: 100%;

                img {
                  width: 20px;
                  height: 20px;
                  margin-top: 10px;
                }

                .line {
                  display: block;
                  width: 2px;
                  height: 40px;
                  background: #f6f7fa;
                  border-radius: 1px;
                  margin: 10px 8px 0 8px;
                }
              }

              &-middle {
                margin: 0 0 0 10px;
                padding: 10px 0 0 10px;
                border-top-left-radius: 8px;
                border-bottom-left-radius: 8px;
                flex: 1;

                .contents {
                  color: rgba(28, 42, 52, 0.85);

                  .state {
                    font-size: 12px;
                    width: 60px;
                    padding: 2px 12px;
                    line-height: 22px;
                    background: rgba(57, 218, 138, 0.08);
                    border-radius: 14px;
                    margin-right: 10px;
                    color: #39da8a;
                  }

                  .state1 {
                    color: rgba(28, 42, 52, 0.45) !important;
                    background: rgba(28, 42, 52, 0.08) !important;
                  }
                }

                .dates {
                  line-height: 18px;

                  img {
                    width: 16px;
                    height: 16px;
                    margin-right: 5px;
                    margin-top: -2px;
                  }

                  color: #000;
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(28, 42, 52, 0.35);
                  margin: 10px 0px 10px 0;
                }
              }

              &-right {
                display: flex;
                width: 145px;
                text-align: center;
                align-items: center;
                justify-items: center;
                display: none;

                .edit-btn {
                  color: rgba(28, 42, 52, 0.45);
                  font-size: 12px;
                  margin-right: 20px;

                  img {
                    width: 14px;
                    height: 14px;
                    margin-right: 6px;
                    margin-top: -2px;
                    cursor: pointer;
                  }

                  img:hover {
                    opacity: 0.8;
                  }
                }

                .state-btn {
                  color: rgba(28, 42, 52, 0.45);

                  label {
                    font-size: 12px !important;
                  }

                  .ivu-checkbox span {
                    width: 14px;
                    height: 14px;
                    color: rgba(28, 42, 52, 0.45);
                    font-size: 12px;
                    border-radius: 50%;
                    margin-right: 6px;
                  }
                }
              }
            }
          }
        }
      }

      &-right {
        width: 300px;
        margin-left: 10px;
        height: calc(100vh - 180px);
        overflow-y: auto;
        .item {
          background-color: #fff;
          border-radius: 8px;
        }

        .log-list {
          margin-top: 20px;
          max-height: calc(100vh - 300px);
          min-height: 100px;
          padding: 10px 10px 0 10px;
          overflow-y: auto;

          &-top {
            height: calc(100vh - 355px);
            overflow-y: auto;

            ul {
              background: rgba(205, 208, 227, 0.1);
              border-radius: 8px;
              margin-bottom: 10px;
              padding: 14px 40px 10px 10px;
              position: relative;

              .edit-btn.active {
                display: block;
              }

              .edit-btn {
                position: absolute;
                right: 20px;
                top: 40%;
                color: rgba(28, 42, 52, 0.35);
                cursor: pointer;
                display: none;
              }

              .date {
                font-size: 12px;
                font-weight: 400;
                color: rgba(28, 42, 52, 0.35);
              }

              .des {
                margin-top: 5px;
                font-weight: 400;
                color: rgba(28, 42, 52, 0.85);
                line-height: 22px;
                word-break: break-all;
              }
            }
          }
        }
      }
    }
  }

  .progress {
    line-height: 20px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;

    span {
      min-width: 48px;
      font-size: 12px;
      color: #1c2a34;
      margin-right: 10px;
    }

    .ivu-progress-inner {
      height: 5px !important;
    }

    .ivu-progress-bg {
      height: 5px !important;
    }

    .ivu-progress-text {
      color: #1c2a34;
      font-size: 12px;
      font-weight: 400;
    }

    .ivu-progress-show-info {
      display: flex !important;
      flex-wrap: nowrap !important;
      justify-content: space-between;
    }

    .ivu-progress-show-info .ivu-progress-outer {
      margin-right: -35px;
      padding-right: 35px;
    }

    .ivu-icon-ios-checkmark-circle {
      color: #39da8a;
    }
  }

  .position {
    display: flex;
    flex-wrap: nowrap;

    .ivu-icon {
      color: rgba(28, 42, 52, 0.35);
      margin: 10px 0 0 30px;
    }
  }

  .mt-20px {
    margin-top: 20px !important;
  }

  .btn {
    border-top: 1px solid #e8e8e8;
    width: 350px;
    height: 50px;
    border-radius: 0px 0px 8px 8px;
    padding-top: 14px;
    padding-right: 20px;
    width: 100%;
    text-align: right;

    p {
      color: #468fef;

      img {
        width: 18px;
        height: 18px;
        margin-right: 7px;
        cursor: pointer;
      }

      img:hover {
        opacity: 0.8;
      }
    }
  }

  .w500 {
    width: 100% !important;
    line-height: 40px !important;
    height: 40px !important;
    padding: 0;
    color: #468fef;
    background: rgba(70, 143, 239, 0.04) !important;
    border-radius: 6px !important;
    border: 1px solid rgba(70, 143, 239, 0.12) !important;
    text-align: center !important;

    span {
      display: inline-block;
      width: 500px;
      line-height: 40px !important;
      font-weight: 400;
      font-size: 14px !important;
      color: #468fef;
      text-align: center !important;
      margin: 0 !important;
    }
  }

  .ivu-page {
    background-color: #fff !important;
    margin: 0 !important;
    padding: 6px 0 !important;
  }

  .noData {
    color: #999;
    text-align: center;
    line-height: 60px;
    margin: auto;
  }

  .ml-10px {
    margin-left: 10px !important;
  }

  .share {
    background-color: #fff;
    padding: 0 20px;
    margin-top: 10px;
    border-radius: 8px;

    .code-state {
      .look {
        color: rgba(28, 42, 52, 0.45);
        cursor: pointer;
      }
    }

    ul {
      line-height: 40px;
    }

    ul:nth-child(1) {
      border-bottom: 1px solid rgba(28, 42, 52, 0.1);
      padding-bottom: 20px;
    }

    .key {
      font-size: 14px;
      font-weight: 400;
      color: #1c2a34;
    }
    .save-btn {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }

    ul:nth-child(2) {
      .ivu-input-wrapper {
        height: 40px !important;
        line-height: 40px;
        margin: 0;
        border-radius: 6px;

        .ivu-input {
          padding: 0 10px;
          height: 40px !important;
          line-height: 40px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }

      .ivu-btn {
        height: 40px !important;
        background: #468fef;
        border-radius: 6px !important;
        margin-top: 1px;
      }
    }
  }

  .milestone-item {
    padding: 22px;
    margin-top: 10px;
    background: #fff;
    border-radius: 8px;
    position: relative;
    // height: 92px;
    overflow: hidden;
    &.expand {
      // height: auto;
      // animation: expandAnimate 1s;
      .expand img {
        transition: all 0.2s;
        transform: rotate(90deg);
      }
      .task-list-m {
        display: block;
      }
      .line-m {
        display: block;
      }
    }
    .line-m {
      width: 1px;
      background: rgba(28, 42, 52, 0.08);
      position: absolute;
      left: 31px;
      top: 40px;
      display: none;
    }
    &-title {
      height: 22px;
      display: flex;
      margin-bottom: 10px;
      .expand {
        width: 18px;
        height: 18px;
        background: #468fef;
        border-radius: 4px;
        margin-right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
        }
      }
      .status {
        height: 22px;
        border-radius: 14px;
        padding: 0 12px;
        line-height: 22px;
        font-size: 12px;
        margin-right: 10px;
        background: rgba(28, 42, 52, 0.08);
        color: rgba(28, 42, 52, 0.45);
        &.done {
          background: rgba(57, 218, 138, 0.08);
          color: #39da8a;
        }
      }
    }
    &-time {
      width: 100%;
      padding-left: 38px;
      font-size: 12px;
      color: rgba(28, 42, 52, 0.35);
      display: flex;
      justify-content: space-between;
      line-height: 16px;
      align-items: center;
      p {
        display: flex;
        align-items: center;
      }
      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
        display: block;
      }
      .action {
        p {
          margin-right: 20px;
        }
      }
    }
    .state-btn {
      color: rgba(28, 42, 52, 0.45);

      label {
        font-size: 12px !important;
      }

      .ivu-checkbox span {
        width: 14px;
        height: 14px;
        color: rgba(28, 42, 52, 0.45);
        font-size: 12px;
        border-radius: 50%;
        margin-right: 6px;
      }
    }
  }

  .task-list-m {
    padding-left: 42px;
    display: none;
    li {
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      background: #fff;
      border: 1px solid rgba(28, 42, 52, 0.1);
      padding: 0 20px;
      color: rgba(28, 42, 52, 0.85);
      position: relative;
    }
    .line {
      width: 20px;
      height: 1px;
      background: rgba(28, 42, 52, 0.08);
      position: absolute;
      left: -33px;
      &::after {
        content: '';
        display: block;
        width: 7px;
        height: 7px;
        background: #468fef;
        border-radius: 50%;
        position: absolute;
        right: -3px;
        top: -3px;
      }
    }
    .star {
      color: rgba(28, 42, 52, 0.45);
      display: flex;
      align-items: center;
      span {
        position: relative;
        top: 1px;
      }
      img {
        height: 16px;
        margin-left: 4px;
      }
    }
  }
}

@keyframes expandAnimate {
  from {
    height: 92px;
  }
  to {
    height: auto;
  }
}
</style>
